<template>
  <div class="help-accordion__item">
    <div class="help-accordion__title" @click.prevent="toggle()">
      <div class="help-accordion__title-inner">
        <slot name="title"></slot>
      </div>
      <button type="button" class="base-btn base-btn--outline-grey help-accordion__button">
        <BaseSvg v-if="opened" name="ico-minus" width="1.2rem" height=".2rem"/>
        <BaseSvg v-else name="ico-plus" width="1.2rem" height="1.2rem"/>
      </button>
    </div>

    <collapse-transition>
      <div v-show="opened" class="help-accordion__inner">
        <slot name="content"></slot>
      </div>
    </collapse-transition>
  </div>

</template>

<script>
  import { CollapseTransition } from "vue2-transitions";

  export default {
    name: "HelpAccordion",
    components: {
      CollapseTransition
    },
    data() {
      return {
        opened: false
      }
    },
    methods: {
      toggle() {
        this.opened = !this.opened;
      }
    }

  }

</script>

<style scoped>

</style>
